import React from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as IconOpenInNew } from 'assets/icons/IconOpenInNew.svg'

const MenuCard = ({ displayName, description, icon, color, isOpenInNew, url }) => {
  return (
    <a className="menu-card" href={url} style={{ backgroundColor: color }}>
      <div className="menu-card__icon">
        <img alt="icon" src={icon} />
      </div>
      <div className="menu-card__info">
        <header>
          <h4 className="menu-card__title">{displayName}</h4>
        </header>
        <p className="menu-card__description">{description}</p>
        <p className="menu-card__cta">Let&apos;s go</p>
        {isOpenInNew && <IconOpenInNew className="menu-card__open-in-new" />}
      </div>
    </a>
  )
}

MenuCard.propTypes = {
  displayName: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  isOpenInNew: PropTypes.bool,
  url: PropTypes.string,
}

MenuCard.defaultProps = {
  isOpenInNew: false,
}

export default MenuCard
